export default __webpack_public_path__ + "54f594f02c27958beb6b08ca32dcb24a.png";